import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useFormContext, Controller } from 'react-hook-form'
import { withTranslation } from 'react-i18next'



export default withTranslation()(function DatePickers({ name, label, variant, sx }) {

  const { control, watch, trigger, getValues, reset } = useFormContext()

  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])

  useEffect(() => { reset({ [name]: null }) }, [name, reset])

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label={label}
            value={watch(name)}
            onChange={onChange}
            renderInput={(params) => {
              return <TextField {...params} sx={sx} variant={variant ?? 'filled'} className={`w-full bg-input rounded-md  ${getValues(name) ? ' ' : ''}`} />
            }}
          />
        </LocalizationProvider>
      )}
    />
  )
})